import PropTypes from 'prop-types';
import React from 'react';

import CancelButton from 'components/buttons/Cancel';
import DeleteButton from 'components/buttons/Delete';
import Card from 'components/Card';
import CardActions from 'components/Card/Actions';
import CardHeader from 'components/Card/Header';
import CardText from 'components/Card/Text';
import Dialog from 'components/Dialog';
import LoadBlur from 'components/LoadBlur';
import RowSpacer from 'components/RowSpacer';

const styles = {
  card: {
  },
};
const DeleteCommentDialog = ({ loading, onConfirm, onRequestClose, open }) => (
  <Dialog
    onRequestClose={onRequestClose}
    open={open}
  >
    <Card style={styles.card}>
      <LoadBlur loading={loading}>
        <CardHeader title='Confirm Delete' />
        <CardText noTopPadding>
          Are you sure you want to delete your comment? Any replies will also be deleted.
        </CardText>
        <CardActions noTopPadding>
          <CancelButton
            forceLabel
            secondary
            onClick={onRequestClose}
          />
          <RowSpacer />
          <DeleteButton
            forceLabel
            primary
            onClick={onConfirm}
          />
        </CardActions>
      </LoadBlur>
    </Card>
  </Dialog>
);

DeleteCommentDialog.propTypes = {
  loading: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

export default DeleteCommentDialog;
